function jasonLogicConditionConstruct(conditions, jlCondition = undefined) {
  if (jlCondition === undefined) {
    jlCondition = {
      if: [],
    };
    //jlCondition = conditions[0].value
  }

  if (conditions.length === 1) {
    return {
      if: [conditions[0].value, conditions[0].postulat],
    };
  }

  const condition = conditions.pop();

  return {
    ...jlCondition,
    if: [
      ...jlCondition.if,
      condition.value,
      condition.postulat,
      jasonLogicConditionConstruct(conditions, jlCondition),
    ],
  };
}

function iterateOverObject(
  obj,
  callback = () => {},
  options = {},
  currentPath = null
) {
  const treatArrayAsObject = options.treatArrayAsObject;

  function cloneShallowArray(arr) {
    return arr.slice(0);
  }

  if (!currentPath) {
    currentPath = [];
  }

  const shouldApplyCompute = obj && (treatArrayAsObject || !Array.isArray(obj));

  if (shouldApplyCompute) {
    Object.keys(obj).forEach(compute);
  }

  return obj;

  function compute(key) {
    const value = obj[key];

    callback(currentPath, key, obj, function (result) {
      if (result.shouldReplace) {
        obj[result.subKey] = result.value;
      } else if (!result.shouldReplace && typeof value === "object") {
        const path = cloneShallowArray(currentPath);
        path.push(key);
        iterateOverObject(value, callback, options, path);
      }
    });
  }
}

export function flowToConfig(originalFlow, currentApp, edgeConfig) {
  let edgeAsCode = edgeConfig?.type === "code" ? true : false;

  // deep object copy
  let flow = JSON.parse(JSON.stringify(originalFlow));

  // guaranteed unique state names
  flow.nodes = flow.nodes.map((node) => {
    return {
      ...node,
      data: {
        ...node.data,
        name: node.data.name.replace(/\s/g, "") + "-" + node.id,
      },
    };
  });

  let stateDataFieldName = "";
  switch (currentApp) {
    case "call-bot":
      // TODO renommer en code ?
      stateDataFieldName = "data";
      break;
    case "allo-brain":
      stateDataFieldName = "store";
      break;
    default:
      stateDataFieldName = "data";
  }

  let states = {};
  let startAt = null;
  flow.nodes.forEach((node) => {
    if (node.data.starter) {
      startAt = node.data.name;
    }

    const {
      type: module,
      description,
      ...otherOptions
    } = node.data.module.options;
    let parameters = node.data.module.parameters;

    // Parameters normalization (removing code, is_code keys)
    /* parameters = iterateOverObject(parameters, function (path, key, obj, callback) {
            if (typeof obj === 'object') {
                Object.keys(obj).forEach(subKey => {

                    if (typeof obj[subKey] === 'object' && obj[subKey].hasOwnProperty('is_code')) {

                        let value = null
                        try {
                            if (!JSON.parse(obj[subKey].code).hasOwnProperty('$')) {
                                value = JSON.parse(obj[subKey].code)
                            } else {
                                value = {
                                    $: JSON.parse(obj[subKey].code)[Object.keys(JSON.parse(obj[subKey].code))[0]]
                                }
                            }
                            callback({
                                shouldReplace: true,
                                value: value,
                                key,
                                subKey
                            })
                        } catch (e) {
                            callback({
                                shouldReplace: false
                            })
                        }

                    } else {
                        callback({
                            shouldReplace: false
                        })
                    }
                })

            }

            return {
                shouldReplace: false
            }

        }, {treatArrayAsObject: true})*/

    let state = {
      module,
      description,
      ...otherOptions,
      [currentApp === "call-bot"
        ? "content"
        : currentApp === "allo-brain"
        ? "input"
        : "parameters"]: parameters,
      [stateDataFieldName]: null,
      next: null,
    };

    let conditions = [];

    /*
     * TODO
     *   faire une condition sur app === callot
     *   faire la meme chose, flow.edges.filter.forEach.....
     *
     *   Ensuite faire pareil pour le forEach des conditions...
     */

    flow.edges
      .filter((edge) => edge.source === node.id)
      .forEach((edge) => {
        if (currentApp === "call-bot" && edgeAsCode) {
          if (edge.data.condition) {
            // next state is conditional
            conditions.push({
              id: edge.id,
              is_code: true,
              code: edge.data.condition.code,
              state: flow.nodes.filter((node) => node.id === edge.target)[0]
                .data.name,
            });
          } else {
            // next state without condition
            conditions.push({
              id: edge.id,
              is_code: false,
              state: flow.nodes.filter((node) => node.id === edge.target)[0]
                .data.name,
            });
          }
        } else {
          try {
            // json logic condition
            const condition = JSON.parse(edge.data.condition || {});
            conditions.push({
              id: edge.id,
              value: condition.$,
              postulat: flow.nodes.filter((node) => node.id === edge.target)[0]
                .data.name,
            });
          } catch (e) {
            conditions.push({
              id: edge.id,
              value: true,
              postulat: flow.nodes.filter((node) => node.id === edge.target)[0]
                .data.name,
            });
            //state.next = flow.nodes.filter(node => node.id === edge.target)[0].data.name
          }
        }
      });

    if (conditions.length) {
      if (currentApp === "call-bot" && edgeAsCode) {
        conditions.sort(
          (a, b) =>
            node.nextNodeListConditions.indexOf(a.id) -
            node.nextNodeListConditions.indexOf(b.id)
        );
        if (conditions.length > 1) {
          state.next = {
            multiple: conditions.length > 1,
            possibilities: conditions.map((condition) => {
              return {
                is_code: condition.is_code,
                code: condition.is_code ? condition.code : null,
                state: condition.state,
              };
            }),
          };
        } else {
          state.next = {
            multiple: false,
            is_code: conditions[0].is_code,
            code: conditions[0].is_code ? conditions[0].code : null,
            state: conditions[0].state,
          };
        }
      } else {
        conditions.sort(
          (a, b) =>
            node.nextNodeListConditions.indexOf(b.id) -
            node.nextNodeListConditions.indexOf(a.id)
        );
        state.next = {
          $: jasonLogicConditionConstruct(conditions),
        };
      }
    }

    // Ajout des data du module dans le state
    try {
      state[stateDataFieldName] = JSON.parse(
        node.data.module.options[stateDataFieldName]
      );
    } catch (e) {
      state[stateDataFieldName] = node.data.module.options[stateDataFieldName];
    }

    // Ajout du state dans les configs
    states[node.data.name] = state;
  });

  let globalParameters = {};
  Object.keys(flow.globalParameters).forEach((key) => {
    try {
      globalParameters[key] = JSON.parse(flow.globalParameters[key]);
    } catch (e) {
      globalParameters[key] = flow.globalParameters[key];
    }
  });

  const configs = {
    ...globalParameters,
    name: flow.name,
    startAt,
    [currentApp === "web-app" ? "pages" : "states"]: states,
  };

  // console.log("llll", flow)

  return iterateOverObject(
    configs,
    function (path, key, obj, callback) {
      if (typeof obj === "object") {
        if (obj[key] && obj[key].hasOwnProperty("is_code")) {
          let value = null;
          try {
            if (!JSON.parse(obj[key].code).hasOwnProperty("$")) {
              value = JSON.parse(obj[key].code);
            } else {
              value = {
                $: JSON.parse(obj[key].code)[
                  Object.keys(JSON.parse(obj[key].code))[0]
                ],
              };
            }

            callback({
              shouldReplace: true,
              value: value,
              subKey: key,
            });
          } catch (e) {
            //pass
          }
        } else if (typeof obj[key] === "string") {
          try {
            callback({
              shouldReplace: true,
              value: JSON.parse(obj[key]),
              subKey: key,
            });
          } catch (e) {
            //pass
          }
        }
      }
      callback({
        shouldReplace: false,
      });
    },
    { treatArrayAsObject: true }
  );
}
